import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// eslint-disable-next-line import/no-cycle
import http from './http';

var withHttp = function withHttp(serviceConfig) {
  var baseURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var serviceMap = {};
  Object.keys(serviceConfig).forEach(function (key) {
    var configOptions = serviceConfig[key];
    serviceMap[key] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _objectSpread2;

      var data,
          requestOptions,
          options,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              requestOptions = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              options = Object.assign(configOptions, requestOptions); // 请求为get时，数据选项的key值为params

              if (options.method.toLowerCase() === 'get') {
                key = 'params';
              } else {
                key = 'data';
              }

              return _context.abrupt("return", http.request(_objectSpread(_objectSpread({}, options), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, key, data), _defineProperty(_objectSpread2, "url", baseURL + options.url), _objectSpread2))));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  });
  return serviceMap;
};

export default withHttp;